import * as React from 'react';

import { type MicrofrontendManifest } from '@/app/shared/types/MicrofrontendManifest';

import { type MicrofrontendAliases } from '../types/MicrofrontendAliases';

const AliasesContext = React.createContext<MicrofrontendAliases>({});

function useAlias(alias: string): MicrofrontendManifest | null {
  const context = React.useContext(AliasesContext);

  return context[alias] || null;
}

export { AliasesContext, useAlias };
